module.exports = __webpack_public_path__ + "static/media/GPS.746fc053.jpg";